import { upperFirst } from "lodash";

const timeFrameI18n = (key) => {
  return I18n.t(`facet_search.time_frame.${key}`);
}

// selected: one of en.facet_search.time_frame.options
// earliest: custom selection earliest date (format "MM-DD-YYYY")
// latest: custom selection latest date (format "MM-DD-YYYY")
export const timeFrameInWords = ({selected, earliest, latest, capitalize = false}) => {
  const momentFormat = (stamp) => {
    return moment(stamp, timeFrameI18n("format.moment")).format(timeFrameI18n("format.description"));
  }

  let label = null;

  // If we're searching all time (10 years), we don't need a label
  if (!selected || selected === "time_any") {
    return label;
  }

  if (selected === "time_custom" && !!earliest && !!latest) {
    const fromLabel = momentFormat(earliest);
    const toLabel = momentFormat(latest);

    label = `${timeFrameI18n("between")} ${fromLabel} ${timeFrameI18n("and")} ${toLabel}`
  } else {
    label = `${timeFrameI18n("in")} ${timeFrameI18n("the")} ${timeFrameI18n(`options.${selected}`)}`
  }

  return capitalize ? upperFirst(label) : label;
};
